import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./Styles/app.scss";

// packages sass framer-motion firebase react-hot-toast react-icons typewriter-effect

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
